import { parseContactTypes } from "./parseContactTypes";
import { parseTags } from "./parseTags";
import { parseTerms } from "./parseTerms";
// import { parsePaymentMethods } from "./parsePaymentMethods";
import { parseContactPersons } from "./parseContactPersons";
import { parseTransactionTableItems } from "./parseTransactionTableItems";
import { parseAccounts } from "./parseAccounts";
import { parseNumberFormats } from "./parseNumberFormats";
import { parseCustomFields } from "./parseCustomFields";

const ListHelper = {
    parseContactTypes,
    parseTags,
    parseTerms,
    // parsePaymentMethods,
    parseCustomFields,
    parseContactPersons,
    parseTransactionTableItems,
    parseAccounts,
    parseNumberFormats,
};

export default ListHelper;
